import ResearchTable from './ResearchTable';

export default ResearchTable;
